import { lazy } from 'react';

export const CourseCreationPage = lazy(() =>
  import('./course-creation-page').then(({ CourseCreationPage }) => ({
    default: CourseCreationPage,
  }))
);
